<template>
  <div ref="modalContainer"></div>
  <a-card class="content-wrapper">
    <template #title>
      <CardHeader></CardHeader>
    </template>
    <div class="body-content">
      <a-form layout="inline">
        <a-form-item label="套餐Id">
          <a-input
            v-model:value="params.id"
            placeholder="请输入套餐Id"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item label="套餐名称">
          <a-input
            v-model:value="params.packageName"
            placeholder="请输入套餐名称"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="doQuery">
            <template #icon>
              <SearchOutlined />
            </template>
            查询
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            class="btn-success"
            @click="showAddModal"
            perm="parking:monthlyRentalPackage:add"
          >
            <template #icon>
              <PlusCircleOutlined />
            </template>
            添加
          </a-button>
        </a-form-item>
      </a-form>
      <div style="padding: 4px 0">
        <a-table
          row-key="id"
          table-layout="auto"
          :data-source="dataList.list"
          :columns="columns"
          :loading="loading"
          :pagination="false"
          :scroll="{ x: 1500, y: 604 }"
          bordered
        >
          <template #packageType="{ text }">
            <a-tag v-if="text==1" :color="'green'">
             月租
            </a-tag>
            <a-tag v-if="text==2" :color="'green'">
              季度
            </a-tag>
            <a-tag v-if="text==3" :color="'green'">
              年租
            </a-tag>
          </template>
          <template #packagePayAmount="{ text }">
            {{ money(text) + "元" }}
          </template>
          <template #operation="{ record }">
            <div>
              <TipButton
                perm="parking:monthlyRentalPackage:edit"
                btn-class="btn-success"
                title="编辑"
                @btnClick="showEditModal(record.id, record, false)"
              >
                <template #default>
                  <EditOutlined />
                </template>
              </TipButton>
              <TipButton
                perm="parking:monthlyRentalPackage:del"
                btn-class="btn-danger"
                title="删除"
                @btnClick="delItem(record.id)"
              >
                <template #default>
                  <DeleteOutlined />
                </template>
              </TipButton>
            </div>
          </template>
        </a-table>
      </div>
      <a-pagination
        v-model:current="page"
        v-model:page-size="pageSize"
        :total="total"
        :show-total="total => `${total}条数据`"
        @change="currentChange"
      >
      </a-pagination>
    </div>
  </a-card>
  <add
    v-if="addShow"
    :modal-ref="$refs.modalContainer"
    @close="hideAddModal"
  ></add>
  <edit
    v-if="editShow"
    :id="currentId"
    :modal-ref="$refs.modalContainer"
    @close="hideEditModal"
  ></edit>
</template>

<script>
import useMonthlyRentalPackage from "@/hooks/parking/useMonthlyRentalPackage";
import usePagination from "@/hooks/usePagination";
import useAddExit from "@/hooks/useAddExit";
import { onMounted } from "vue";
import useMessage from "@/hooks/useMessage";
import Add from "@/views/Parking/MonthlyRentalPackage/components/Add";
import Edit from "@/views/Parking/MonthlyRentalPackage/components/Edit";
import TipButton from "@/components/TipButton";
import CardHeader from "@/components/CardHeader";
import { deleteMonthlyRentalPackage } from "../../../api/parking/monthlyRentalPackage";

export default {
  name: "index",
  components: {
    Edit,
    Add,
    CardHeader,
    TipButton,
  },
  setup() {
    const {
      loading,
      params,
      dataList,
      total,
      columns,
      loadData,
      parkingLotList,
      money,
    } = useMonthlyRentalPackage();

    const { page, pageSize, currentChange, doQuery,doRefresh } = usePagination(loadData);

    const {
      currentId,
      addShow,
      editShow,
      showAddModal,
      showEditModal,
      hideAddModal,
      hideEditModal,
    } = useAddExit(doQuery);

    const { showConfirm, showLoading, closeLoading, showTipMessage, showErr } =
      useMessage();

    onMounted(() => {
      loadData(page.value, pageSize.value);
    });

    const delItem = async id => {
      let action = await showConfirm("删除后不可恢复，是否确认删除当前套餐?");
      if (action) {
        await showLoading("正在删除，请稍后...");
        try {
          await deleteMonthlyRentalPackage(id);
          await closeLoading();
          await showTipMessage("删除成功", "success");
          doQuery();
        } catch (e) {
          await closeLoading();
          await showErr(e);
        }
      }
    };

    return {
      parkingLotList,
      params,
      page,
      pageSize,
      total,
      loading,
      currentChange,
      dataList,
      doQuery,
      doRefresh,
      columns,

      currentId,
      addShow,
      editShow,
      showEditModal,
      showAddModal,
      hideAddModal,
      hideEditModal,
      delItem,
      money,

    };
  },
};
</script>

<style scoped></style>
